export default {"src":"/_next/static/media/unchecked_box.25c051d6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};